// extracted by mini-css-extract-plugin
export default {"register-form":"RegisterForm_register-form__nCC4m","input":"RegisterForm_input__lgNH0"};